import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\CheckValidatedPersonController::__invoke
* @see app/Http/Controllers/Person/CheckValidatedPersonController.php
* @route '/api/check-person'
*/
const CheckValidatedPersonController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CheckValidatedPersonController.url(options),
    method: 'post',
})

CheckValidatedPersonController.definition = {
    methods: ["post"],
    url: '/api/check-person',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Person\CheckValidatedPersonController::__invoke
* @see app/Http/Controllers/Person/CheckValidatedPersonController.php
* @route '/api/check-person'
*/
CheckValidatedPersonController.url = (options?: RouteQueryOptions) => {
    return CheckValidatedPersonController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\CheckValidatedPersonController::__invoke
* @see app/Http/Controllers/Person/CheckValidatedPersonController.php
* @route '/api/check-person'
*/
CheckValidatedPersonController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CheckValidatedPersonController.url(options),
    method: 'post',
})

export default CheckValidatedPersonController